
import { initializeApp } from "firebase/app";


import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
  setDoc,
  doc,
} from "firebase/firestore";
import AddStudent from "../Components/Student/AddStudent";
import { addStudent, addTeacher } from "./firebaseFunctions";

const firebaseConfig = {
    apiKey: "AIzaSyAavlvevY90d-77zZtfJAv5CNgUx85N8mk",
    authDomain: "real-i-f0282.firebaseapp.com",
    projectId: "real-i-f0282",
    storageBucket: "real-i-f0282.appspot.com",
    messagingSenderId: "1069644502911",
    appId: "1:1069644502911:web:ef78ca6f4be3663e6eec4a"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password).then(async (user)=>  {
 
        localStorage.setItem("user", user.user );
        localStorage.setItem("uid", user.user.uid );
        try {
            const docRef = await setDoc(doc(db, "users", user.user.uid), {
                uid: user.user.uid,
                authProvider: "local",
                email: user.user.email,
              });

          } catch (e) {
            alert("Error adding document: ", e);
            return false;
          }
          
        } );
        return true;

} catch (err) {
    console.error(err);
  
    return err
  }
};

const registerWithEmailAndPasswordStudent = async (name, email, password, course, dob, sponser, gender,familyIncome, disability, noOfSiblings, distanceFromSchool, toiletFacilities, drinkingWater, previousPregnency, percentage) => {

    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;
        addStudent(user.uid, name, email, course, sponser, localStorage.getItem("schoolID") ?? "001", gender,familyIncome, dob, disability, noOfSiblings, distanceFromSchool, toiletFacilities, drinkingWater, previousPregnency,percentage)
        
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
  
    
};

const registerWithEmailAndPasswordTeacher = async (name, email, password, course, dob) => {

      try {
          const res = await createUserWithEmailAndPassword(auth, email, password);
          const user = res.user;
          addTeacher(name, course,localStorage.getItem("schoolID") ?? "001", dob, user.uid, user.email)
          
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
       
  };

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPasswordStudent,
  registerWithEmailAndPasswordTeacher,
  sendPasswordReset,
  logout,
};